import {createReducer, on, State} from '@ngrx/store';
import {
  loadCotsTypeFailure,
  loadCotsTypes, loadCotsTypeSuccess,
  loadMaterialFamilies,
  loadMaterialFamiliesFailure,
  loadMaterialFamiliesSuccess,
  loadOrganizations,
  loadOrganizationsFailure,
  loadOrganizationsSuccess,
  loadShapeTypes, loadShapeTypesFailure,
  loadShapeTypesSuccess


} from "./global-config-dropdown.action";
import {StateStatus} from "../../../shared/models/state-status.models";
import {CotsType, Organization, ShapeType} from "../../models/global-config.models";
import {MaterialFamily} from "../../models/materials.model";
import {v4 as uuidv4} from 'uuid';

export interface GlobalConfigDropdownState {
  materialFamilies: MaterialFamily[];
  materialFamilyStatus: StateStatus;

  organizations: Organization[];
  organizationStatus: StateStatus;

  shapeTypes: ShapeType[];
  shapeTypeStatus: StateStatus;

  cotsTypes: CotsType[];
  cotsTypeStatus: StateStatus;

  error: string | null;
}

export const initialState: GlobalConfigDropdownState = {
  materialFamilies: [],
  materialFamilyStatus: 'pending' as StateStatus,
  organizations: [],
  organizationStatus: 'pending' as StateStatus,
  shapeTypes: [],
  shapeTypeStatus: 'pending' as StateStatus,
  cotsTypes: [],
  cotsTypeStatus: 'pending' as StateStatus,
  error: null,
};

export const globalConfigDropdownReducer = createReducer(
  initialState,
  on(loadMaterialFamilies, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(loadMaterialFamiliesSuccess, (state, { materialFamilies }) => ({
    ...state,
    materialFamilies: materialFamilies,
    error: null,
    materialFamilyStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadMaterialFamiliesFailure, (state, { error }) => ({
    ...state,
    error: error,
    materialFamilyStatus: 'error' as StateStatus,
  })),

  on(loadOrganizations, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(loadOrganizationsSuccess, (state, { organizations }) => ({
    ...state,
    organizations: organizations,
    error: null,
    organizationStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadOrganizationsFailure, (state, { error }) => ({
    ...state,
    error: error,
    organizationStatus: 'error' as StateStatus,
  })),

  on(loadShapeTypes, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(loadShapeTypesSuccess, (state, { shapeTypes }) => ({
    ...state,
    shapeTypes: shapeTypes,
    error: null,
    shapeTypeStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadShapeTypesFailure, (state, { error }) => ({
    ...state,
    error: error,
    shapeTypeStatus: 'error' as StateStatus,
  })),

  on(loadCotsTypes, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(loadCotsTypeSuccess, (state, { cotsTypes }) => ({
    ...state,
    cotsType: cotsTypes,
    error: null,
    cotsTypeStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadCotsTypeFailure, (state, { error }) => ({
    ...state,
    error: error,
    cotsTypeStatus: 'error' as StateStatus,
  })),

);
